import type { Card } from '@/types'

export function getSetPriority(code: string | null): number {
  if (!code) return 5
  if (code.startsWith('OP')) return 1
  if (code.startsWith('EB')) return 2
  if (code.startsWith('PRB')) return 3
  if (code.startsWith('ST')) return 4
  if (code.startsWith('DON')) return 99
  return 5
}

const RARITY_ORDER: Record<string, number> = {
  L: 0,
  SEC: 1,
  SP: 2,
  SR: 3,
  R: 4,
  UC: 5,
  C: 6,
}

const CARD_COMPARATORS: Record<string, (a: Card, b: Card) => number> = {
  card_image_id: (a, b) => {
    const pa = getSetPriority(a.setCode ?? a.cardImageId)
    const pb = getSetPriority(b.setCode ?? b.cardImageId)
    return pa - pb || a.cardImageId.localeCompare(b.cardImageId)
  },
  name: (a, b) => a.name.localeCompare(b.name),
  cost: (a, b) => (a.cost ?? Infinity) - (b.cost ?? Infinity),
  power: (a, b) => (a.power ?? Infinity) - (b.power ?? Infinity),
  price: (a, b) => (a.marketPrice ?? -Infinity) - (b.marketPrice ?? -Infinity),
  rarity: (a, b) => (RARITY_ORDER[a.rarity ?? ''] ?? 99) - (RARITY_ORDER[b.rarity ?? ''] ?? 99),
}

export function sortCards(cards: Card[], sort?: string, order?: 'asc' | 'desc'): Card[] {
  if (!sort) return cards

  const compare = CARD_COMPARATORS[sort]
  const sorted = [...cards]
  const dir = order === 'desc' ? -1 : 1

  // Unknown sort keys fall through to the stable id tiebreak, like before.
  sorted.sort((a, b) => (compare ? compare(a, b) * dir : 0) || a.id - b.id)
  return sorted
}
